import React from 'react'

import { Link } from 'react-router-dom'
import styled from 'styled-components'


const RoomsList = ({ rooms }) => {


  return (
    <StyledRoomList>
      {rooms?.map((room) => <StyledRoom key={room._id} to={`/room/${room._id}`}>
        <strong>{room.Name}</strong>
        {room.streams?.map(s => <p key={s._id}>{s?.users_permissions_user?.username}</p>)}
      </StyledRoom>)}
    </StyledRoomList>
  )
}
export default RoomsList

const StyledRoom = styled(Link)`
  padding: 1em;
  margin: 1em;
  background-color: #e6e6e6;
  `
const StyledRoomList = styled.div`
  display: flex;
  padding: 1em;
  margin: 1em;
`